const it = {
    '/': {
        title: '{brand} & Scommesse Sportive | Prelievi Crypto Istantanei',
        description: '{brand} e scommesse sportive in un unico wallet. Slot, casinò live e giochi provably fair, con prelievi in criptovaluta istantanei.',
        keywords: 'casinò crypto, casinò bitcoin, scommesse sportive crypto, slot crypto, prelievi istantanei, casinò provably fair'
    },
    '/casino': {
        title: 'Casino Online | Slot, Blackjack & Dealer Live | {brand}',
        description: 'Slot, blackjack, roulette & dealer live su {brand}. Centinaia di giochi, depositi crypto veloci & prelievi istantanei disponibili 24/7.',
        keywords: 'casinò crypto, giochi casinò bitcoin, casinò online, slot crypto, casinò live, blackjack, roulette'
    },
    '/sports': {
        title: 'Scommesse Sportive Online | Scommesse Crypto & Quote | {brand}',
        description: 'Scommetti sullo sport su {brand}. Quote competitive su calcio, basket & altro. Scommesse live, puntate crypto sicure & pagamenti rapidi.',
        keywords: 'scommesse sportive crypto, bookmaker bitcoin, scommesse live, quote calcio, scommesse esports'
    },
    '/livecasino': {
        title: 'Casino Live | Blackjack, Roulette & Dealer dal Vivo | {brand}',
        description: 'Blackjack, roulette & giochi di casino live su {brand}. Dealer reali, streaming HD & ampia selezione di tavoli live disponibili 24/7.',
        keywords: 'casinò live, croupier dal vivo, blackjack live, roulette live, baccarat live, game show'
    },
    '/slots': {
        title: 'Slot Online | Ampia Varietà di Slot da Casino | {brand}',
        description: "Un'enorme collezione di slot su {brand}. Macchine classiche, video slot & progressive, tutte giocabili con crypto.",
        keywords: 'slot crypto, slot bitcoin, slot online, video slot, slot megaways, bonus buy slot'
    },
    '/vip': {
        title: 'Programma VIP | Premi Esclusivi & Vantaggi | {brand}',
        description: 'Il programma VIP di {brand}: premi esclusivi, bonus personalizzati e supporto prioritario. Vantaggi per i giocatori fedeli.',
        keywords: 'programma vip casinò, rakeback, premi fedeltà casinò, casinò high roller, livelli vip'
    },
    '/welcome-offer': {
        title: 'Offerta di Benvenuto | Casino Crypto | {brand}',
        description: "Scopri l'offerta di benvenuto di {brand}. Inizia con le crypto e goditi vantaggi esclusivi per i nuovi giocatori.",
        keywords: 'bonus di benvenuto casinò, bonus casinò crypto, bonus primo deposito, offerta nuovi giocatori'
    },
    '/referral': {
        title: 'Programma di Referral | Guadagna Premi | {brand}',
        description: 'Invita amici su {brand} e guadagna premi quando si iscrivono e soddisfano i requisiti.',
        keywords: 'programma referral casinò, bonus invita un amico, premi affiliati'
    },
    '/promotion-page': {
        title: 'Promozioni | Bonus & Offerte Speciali | {brand}',
        description: 'Tutte le promozioni attive su {brand}. Bonus, giri gratuiti e offerte speciali per i giocatori crypto.',
        keywords: 'promozioni casinò, bonus casinò crypto, gara settimanale, tornei casinò'
    },
    '/hotslots': {
        title: 'Slot Popolari | Slot Casino Più Giocate | {brand}',
        description: 'Gioca alle slot più popolari su {brand}. Le slot più calde disponibili con crypto.'
    },
    '/newgames': {
        title: 'Nuovi Giochi | Ultimi Giochi da Casino | {brand}',
        description: 'Scopri i più recenti giochi da casino su {brand}. Nuove slot, giochi live e giochi da tavolo aggiunti regolarmente.'
    },
    '/populargames': {
        title: 'Giochi Popolari | I Giochi da Casino Più Giocati | {brand}',
        description: 'I giochi da casino più popolari su {brand}. Dalle slot ai giochi live, tutto disponibile con crypto.'
    },
    '/gameshows': {
        title: 'Game Show | Casino con Show dal Vivo | {brand}',
        description: 'Goditi i migliori game show dal vivo su {brand}. Conduttori veri, giochi unici e grandi vincite in tempo reale.'
    },
    '/table_games': {
        title: 'Giochi da Tavolo | Blackjack, Roulette & Baccarat | {brand}',
        description: 'Gioca a blackjack, roulette, baccarat e altri giochi da tavolo su {brand}. Tutto disponibile con crypto.'
    },
    '/hotlive': {
        title: 'Casino Live Popolare | Giochi Live Più Giocati | {brand}',
        description: 'I giochi di casino live più popolari su {brand}. Gioca con veri dealer in tempo reale.'
    },
    '/featurebuyin': {
        title: 'Slot con Acquisto Bonus | Feature Buy-in | {brand}',
        description: 'Gioca a slot con la possibilità di acquistare il bonus su {brand}. Accedi direttamente al round bonus senza aspettare.'
    },
    '/originals': {
        title: 'Giochi Casino Originali | Titoli Esclusivi | {brand}',
        description: "Gioca a giochi originali esclusivi su {brand}. Titoli unici che non troverai da nessun'altra parte, sviluppati internamente per un'esperienza casino senza pari."
    },
    '/providers': {
        title: 'Fornitori di Giochi | Partner Studio & Software | {brand}',
        description: 'Esplora tutti i fornitori di giochi su {brand}. Collaboriamo con i migliori studi per offrirti una libreria crypto diversificata e di alta qualità.'
    },
    '/about-us': {
        title: 'Chi Siamo | Scopri di più su {brand}',
        description: 'Scopri {brand}, un casino crypto & sportsbook leader. Impegnati in un gioco sicuro, equo & emozionante con prelievi crypto istantanei.'
    },
    '/affiliate': {
        title: 'Programma Affiliati | Guadagna Crypto con {brand}',
        description: 'Diventa partner di {brand} & guadagna commissioni promuovendo il nostro casino crypto. Tariffe competitive, monitoraggio in tempo reale & supporto dedicato agli affiliati.'
    },
    '/faq': {
        title: 'FAQ | Domande Frequenti | {brand}',
        description: 'Trova risposte alle domande più comuni su {brand}. Consulta la nostra FAQ per aiuto con account, pagamenti, bonus & giochi da casino.'
    },
    '/aml-policy': {
        title: 'Politica AML | Antiriciclaggio su {brand}',
        description: 'La politica AML di {brand} garantisce un ambiente sicuro e affidabile. Leggi le nostre misure per prevenire attività illecite sulla nostra piattaforma.'
    },
    '/bonus-terms': {
        title: 'Termini e Condizioni dei Bonus | Promozioni {brand}',
        description: 'Leggi le regole dei bonus & promozioni di {brand}. Scopri come richiedere, utilizzare & ritirare le vincite dei bonus dalla nostra piattaforma.'
    },
    '/complaints-and-arbitration': {
        title: 'Reclami e Arbitrato | Supporto Giocatori su {brand}',
        description: 'Scopri il processo di gestione dei reclami & risoluzione delle controversie di {brand}. Garantiamo un trattamento equo e risolviamo i problemi rapidamente e in modo trasparente.'
    },
    '/fairness': {
        title: 'Giochi Provabilmente Equi | Garanzia di Equità su {brand}',
        description: '{brand} utilizza la tecnologia provably fair per garantire che ogni risultato sia verificabile, trasparente & completamente casuale.'
    },
    '/kyc-policy': {
        title: "Politica KYC | Verifica dell'Identità su {brand}",
        description: "La politica KYC di {brand} descrive il nostro processo di verifica dell'identità. Scopri come proteggiamo i giocatori e manteniamo un ambiente di gioco sicuro."
    },
    '/payment-policy': {
        title: 'Politica di Pagamento | Depositi & Prelievi in Crypto | {brand}',
        description: '{brand} accetta depositi & prelievi in crypto. Leggi la nostra politica di pagamento per limiti di transazione, criptovalute accettate & tempi di elaborazione.'
    },
    '/privacy-policy': {
        title: 'Informativa sulla Privacy | Protezione dei Dati su {brand}',
        description: "L'informativa sulla privacy di {brand}. Scopri come raccogliamo, utilizziamo & proteggiamo i tuoi dati personali sulla nostra piattaforma di casino crypto."
    },
    '/responsible-gaming': {
        title: 'Gioco Responsabile | Gioca in Sicurezza su {brand}',
        description: '{brand} è impegnata nel gioco responsabile. Accedi a strumenti & risorse per gestire le tue abitudini di gioco e giocare in sicurezza.'
    },
    '/terms-of-service': {
        title: 'Termini di Servizio | {brand}',
        description: "Consulta i termini & condizioni che regolano l'utilizzo di {brand}. Comprendi i tuoi diritti e responsabilità come giocatore."
    },
    '/terms-sports': {
        title: 'Termini e Condizioni delle Scommesse Sportive | {brand}',
        description: 'I termini & condizioni delle scommesse sportive di {brand}. Regole per piazzare scommesse, riscuotere vincite & utilizzare lo sportsbook sulla nostra piattaforma.'
    },
    '/special-bets': {
        title: 'Scommesse speciali | Palinsesto crypto | {brand}',
        description: 'Piazza scommesse speciali su {brand}. Mercati su sport, esport & eventi singoli, con depositi crypto istantanei e pagamenti rapidi.'
    },
    '/transparency': {
        title: 'Trasparenza | Casinò crypto a equità dimostrabile | {brand}',
        description: 'Scopri come {brand} opera allo scoperto. Verifica dell’equità dimostrabile, tassi di ritorno pubblicati dal catalogo live & pagamenti on-chain.'
    },
    '/faq/about': {
        title: 'Chi è {brand} | Domande frequenti',
        description: 'Su {brand}: licenza, come funziona il casinò crypto & cosa rende equa la piattaforma. Risposte alle domande più comuni.'
    },
    '/faq/account': {
        title: 'Account | Domande frequenti | {brand}',
        description: 'Gestire il tuo account {brand}: registrazione, accesso, verifica & impostazioni del profilo. Risposte alle domande più comuni.'
    },
    '/faq/bonuses': {
        title: 'Bonus | Domande frequenti | {brand}',
        description: 'I bonus {brand} spiegati: offerte di benvenuto, codici promozionali, requisiti di puntata & premi. Risposte alle domande più comuni.'
    },
    '/faq/deposits': {
        title: 'Depositi | Domande frequenti | {brand}',
        description: 'Come depositare crypto su {brand}: monete supportate, reti, minimi & tempi di conferma. Risposte alle domande più comuni sui depositi.'
    },
    '/faq/games-sports': {
        title: 'Giochi & sport | Domande frequenti | {brand}',
        description: 'Giochi da casinò & scommesse sportive su {brand}: fornitori, equità dimostrabile, quote & scommesse live. Risposte alle domande più comuni.'
    },
    '/faq/responsible-gambling': {
        title: 'Gioco responsabile | Domande frequenti | {brand}',
        description: 'Gioco responsabile su {brand}: limiti di deposito, autoesclusione, periodi di pausa & strumenti di supporto per giocare in sicurezza.'
    },
    '/faq/security': {
        title: 'Sicurezza | Domande frequenti | {brand}',
        description: 'Sicurezza su {brand}: protezione dell’account, autenticazione a due fattori, equità & privacy dei dati. Risposte alle domande più comuni.'
    },
    '/faq/support-disputes': {
        title: 'Assistenza & contestazioni | Domande frequenti | {brand}',
        description: 'Come ottenere aiuto su {brand}: chat dal vivo, tempi di risposta & come si risolvono le contestazioni. Risposte alle domande più comuni.'
    },
    '/faq/withdrawals': {
        title: 'Prelievi | Domande frequenti | {brand}',
        description: 'Come prelevare crypto da {brand}: tempi di pagamento, minimi, commissioni & limiti. Risposte alle domande più comuni sui prelievi.'
    }
};
export default it;
